<template>
  <div id="app">
    <router-view />
    <p style="opacity: 0; height: 0; width: 0; overflow: hidden;">Pipeline migration test</p>
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {}
  },
  created() {
    // http://localhost:8081/tasklist?process=1&unfinished=1&token=eyJhbGciOiJIUzI1NiJ9.eyJqdGkiOiI2M2JlMTNmOWE5OTQ0NDdhYmYwNmIwYzk3YzQ4MmJlZiIsImlzcyI6ImRyYWdvbmxldHRlcjMuMCIsInN1YiI6IntcInVzZXJJZFwiOlwiYTNhMTBkZGItNzcyMC00MjU5LThhNjUtZGY2ZjMxZTZhODFlXCIsXCJ1c2VyTmFtZVwiOlwibml1cnVpZ2FuZ1wifSIsImlhdCI6MTU5NzcxNDA1MywiZXhwIjoxNTk3NzUwMDUzfQ.JRzlfR34u3kNUMhFGozoW7iFnkEMvwOrDgbkEYqmOAs&qqq=undefined
    if (this.$route.query.token) {
      sessionStorage.setItem('longchat-token', this.$route.query.token)
    }
  },
  methods: {
  }
}
</script>
